import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent, FormFieldComponent } from '@akostm/orbit-ui';
import { TenantStore } from '../../../stores';
import { ResetPassword } from '../../../interfaces';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'shared-reset-password-form',
  standalone: true,
  imports: [CommonModule, ButtonComponent, FormFieldComponent, ReactiveFormsModule, TranslatePipe],
  templateUrl: './reset-password-form.component.html',
  styleUrl: './reset-password-form.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordFormComponent implements OnInit {
  readonly tenantStore = inject(TenantStore);
  readonly #translateService: TranslateService = inject(TranslateService);
  readonly #activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  readonly #router: Router = inject(Router);
  errorMessage = '';
  tenantName = this.tenantStore.name();
  resetPasswordAttempt = output<ResetPassword>();

  resetPasswordForm = new FormGroup({
    email: new FormControl<string | null>(null),
  });

  ngOnInit() {
    this.#activatedRoute.queryParams.subscribe((param) => {
      if (param['email']) {
        this.email.setValue(param['email']);
      }
    });
  }

  get email() {
    return this.resetPasswordForm.get('email') as FormControl<string>;
  }

  onSubmit() {
    if (!this.email.value) {
      this.errorMessage = this.#translateService.instant('SHARED.LOGIN.ERROR_MESSAGE');
      return;
    }
    this.errorMessage = '';
    const givenCredentials = { email: this.email.value };
    this.resetPasswordAttempt.emit(givenCredentials);
  }

  goToLogin() {
    this.#router.navigate(['/login']);
  }
}
